import { Amplify } from "aws-amplify"; 
const { USER_POOL_ID, CLIENT_ID } = window.APP_CONFIG;

Amplify.configure({
  Auth: {
    Cognito: {
    userPoolId: CLIENT_ID,
    userPoolClientId: USER_POOL_ID,
    },
  },
});